<div
  class="mobile-carousel"
  [class.bottom-padding]="pageData.background_image_web?.data?.attributes?.url"
  [style.background-image]="
    pageData.background_image_web?.data?.attributes?.url &&
    'url(' + pageData.background_image_web?.data?.attributes?.url + ')'
  "
>
  <app-vertical-carousel [carousel]="carousel">
    <ng-template let-slide>
      <app-protect-and-save-carousel-slide
        [slide]="slide"
      ></app-protect-and-save-carousel-slide>
    </ng-template>
  </app-vertical-carousel>
</div>
<div
  class="desktop-carousel"
  [style.background-image]="
    pageData.background_image_web?.data?.attributes?.url &&
    'url(' + pageData.background_image_web?.data?.attributes?.url + ')'
  "
>
  <app-slider-component [carousel]="carousel">
    <ng-template let-slide>
      <div class="desktop-slide-wrapper">
        <h2>{{ slide.title }}</h2>
        <div class="slide-bottom">
          <p>{{ slide.description }}</p>
          <a [href]="slide.route">
            <button class="button">Find out more</button>
          </a>
        </div>
      </div>
    </ng-template>
  </app-slider-component>
</div>
